import { ButtonType } from "./ButtonsData";

export const buttonsTypeDataAutomation = {
  [ButtonType.union]: 'dropdown-button-type-union-category',
  [ButtonType.casual]: 'dropdown-button-type-casual',
  [ButtonType.sur]: 'dropdown-button-type-union-surplus',
  [ButtonType.tel]: 'dropdown-button-type-telephone'
}